import { useEffect } from 'react';

const useEscapeHandlers = (getter, setter, contentRef, focusRef) => {
  const handleKeyPress = (e) => {
    if (e.key === "Escape") {
      if (getter) {
        setter(false);
      }
    }
  };
  const handleClickOutside = (e) => {
    if (!contentRef.current) {
      return;
    }
    if (!contentRef.current.contains(e.target)) {
      setter(false);
    }
  };
  useEffect(() => {
    if (getter) {
      window.addEventListener("pointerdown", handleClickOutside);
    }
    return () => window.removeEventListener("pointerdown", handleClickOutside);
  }, [getter]);
  useEffect(() => {
    document.removeEventListener("keydown", handleKeyPress);
    if (getter && focusRef?.current) {
      focusRef.current.focus({
        preventScroll: true
      });
      document.addEventListener("keydown", handleKeyPress);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [getter]);
  return null;
};

export { useEscapeHandlers as default };
//# sourceMappingURL=useEscapeHandlers.js.map
